import React from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Concierge from "@/components/Concierge";

export default function Layout({ children, hideConcierge }) {
  return (
    <div className="App flex flex-col min-h-screen">
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
      {!hideConcierge && <Concierge />}
    </div>
  );
}
